import React from 'react';

const Features = () => (
  <section id="features" className="features animate">
  <h1>Features</h1>
  <div className="features-grid">
    {[
      { icon: 'fa-solid fa-key', title: 'No API Keys', desc: 'Start working without complicated setups or API keys.' },
      { icon: 'fa-solid fa-rocket', title: 'Fast Processing', desc: 'AI processes your data quickly and efficiently.' },
      { icon: 'fa-solid fa-chart-line', title: 'Smart Analysis', desc: 'Identify trends and insights effortlessly.' },
      { icon: 'fa-solid fa-comments', title: 'Natural Language Inputs', desc: 'Interact with your data using simple language.' },
      { icon: 'fa-solid fa-robot', title: 'AI Automation', desc: 'Automate repetitive tasks and streamline workflows.' },
      { icon: 'fa-solid fa-shield-alt', title: 'Secure', desc: 'Your data stays private and protected at all times.' },
      { icon: 'fa-solid fa-brain', title: 'AI-Powered Insights', desc: 'Get intelligent insights directly in Google Sheets.' },
      { icon: 'fa-solid fa-piggy-bank', title: 'Cost-efficient', desc: 'Save time and resources with optimized tools.' },
    ].map((feature, index) => (
      <div key={index} className="feature">
        <i className={feature.icon}></i>
        <h3>{feature.title}</h3>
        <p>{feature.desc}</p>
      </div>
    ))}
  </div>
</section>

);

export default Features;
